import { render, staticRenderFns } from "./Sentence.vue?vue&type=template&id=195687fb&scoped=true&"
import script from "./Sentence.vue?vue&type=script&lang=ts&"
export * from "./Sentence.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./Sentence.vue?vue&type=style&index=0&id=195687fb&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "195687fb",
  null
  ,true
)

export default component.exports